import React from "react";
import { EditNakiStoreFeaturedSectionContentModalTemplate } from "themes/administration/naki-store/components";

function EditNakiStoreFeaturedSectionContentModal(props) {
    return <EditNakiStoreFeaturedSectionContentModalTemplate {...props} />;
}

export default EditNakiStoreFeaturedSectionContentModal;
